module.exports = __webpack_public_path__ + "static/media/thumb.f516d05f.svg";